'use strict'

import $ from 'jquery';
import * as cart from '../api/cart';
import headerCart from '../checkout/header-cart';
import numberstepper from '../ui/numberstepper';
import productPage from '../product/product-page';
import { openModal } from '../ui/modal';
import clickAndCollect from '../product/click-and-collect';
import Mustache from 'mustache';
import { sesStorage } from '../util/sessionStorage';

export default function() {

	const $container = $('.package-builder');
	const $cartbutton = $('.add-package-to-cart-button');
	const $formAlertContainer = $('#product-alert-container');
	const $toggles = $container.find('.package-group');
	const $groups = initProductGroups($toggles);
	const $questionsLink = $('.js-questions-modal-link');
	const $questionsContent = $('.js-questions-modal-content');
	const $questionsConfirmationContent = $('.js-questions-confirmation-modal');
	const targetgroups = $('.btn-package-targetgroup');
	const groupCartTemplate = $('#groupCartTemplate');
	const $heroBg = $('.hero-packagebuilder .hero-bg');
	const $bindingsGroup = $('[data-categoryname="siteet"]');

	const targetgroupProductCache = {};
	const uservalues = {
		targetgroup: null,
		uuid: {}
	};
	const requiredvalues = {};
	let validvalues = false;
	let ignore_ski_height = false;
	let ignoreFixedPrice = false;

	setHeroBackgroundImage();
	initUserChoices();
	accordion();

	// Handle cart
	$cartbutton.on('click', addPackageToCart);

	// Handle back button
	let overlaycount = 0;
	window.onpopstate = function (ev) {

		// First close product layer
		if ($.magnificPopup.instance.isOpen) {
			$.magnificPopup.close();

			// Else close product list accordion
		} else if ($groups.is('.in')) {
			$groups.collapse('hide');
		}

		// Decrement overlay count
		overlaycount = Math.max(0, overlaycount - 1);
	};

	// If url parameter item is given this will fill user info and select items OR items in session storage
	getProductsFromPackage();

	$.each($questionsLink, function (index, value) {
		$($questionsLink).on('click', function(e) {
			e.preventDefault();
			$.each($questionsContent.find('.js-fetch-link-content'), function (i, val) {
				$.get($(this).attr('href'), (data) => {
					if (data) {
						$(this).parent().append(data);
						$(this).remove();
					}
				});
			});
			openModal($questionsLink, { compact: true, disableBodyScroll: true });
		});
	});

	$questionsConfirmationContent.find('.js-restart').on('click', function() {
		if ($(this).data('key')) {
			changeTargetGroup($('.btn-package-targetgroup[data-key="' + $(this).data('key') + '"]'));
		}
		$.each($('.package-input input, .package-input select'), function (i) {
			updateUserData($(this).data('uuid'));
		});

		sesStorage('remove', 'intersport-package-item');

		handlePreAttachedBindings(false);
		resetGroupsProducts();
		$.magnificPopup.close();
	});

	$questionsConfirmationContent.find('.js-close-modal').on('click', function() {
		$.magnificPopup.close();
	});

	function setHeroBackgroundImage() {
		const heroDataAttributes = $heroBg.data();
		if (typeof heroDataAttributes !== 'undefined') {
			if ($(window).width() > 480 && heroDataAttributes.desktopBg) {
				$heroBg.css('background', heroDataAttributes.desktopBg)
			}
			else if (heroDataAttributes.mobileBg){
				$heroBg.css('background', heroDataAttributes.mobileBg)
			}
		}
	}

	function addSessionStorageHTML () {
		if ($('.hero.hero-packagebuilder .hero-content .local-storage-text').length === 0) {
			$('.hero.hero-packagebuilder .hero-content').append('<p class="local-storage-text text-center">Tiedot haettiin selaimen muistista.<br><a href="#" class="js-remove-from-local-storage a-link">Poista tallennetut tiedot.</a></p>');
			$('.js-remove-from-local-storage').on('click', function(e) {
				e.preventDefault();
				sesStorage('remove', 'intersport-package-item');
				sesStorage('remove', 'intersport-userinfo');
				sesStorage('remove', 'intersport-products');
				location.reload();
			});
		}
	}

	/**
   * If url contains item parameter lets get package from cart or products via ajax if fixed package and select items and fill user given info
   */
	function getProductsFromPackage () {

		// Display text and link to remove local storage data (cart package item)
		if (!$container.data('item') && sesStorage('get', 'intersport-package-item') || sesStorage('get', 'intersport-userinfo') && !$container.data('item') && !sesStorage('get', 'intersport-package-item')) {
			$container.data('item', sesStorage('get', 'intersport-package-item'));
			addSessionStorageHTML();
		}

		// User info and products to local storage. (User came to page via cart package link)
		if ($container.data('item')) {

			sesStorage('set', 'intersport-package-item', $container.data('item'));
			sesStorage('remove', 'intersport-userinfo');
			let itemId = $container.data('item');
			cart.getCart(true, { richProductData: 1 }).then(data => {
				const item = data.cart.reservedItems.find(item => item.id === itemId);
				addProductsFromPackage(item);
			});

		} else {

			// User info stored in local storage. (User has given infos on freshly loaded page and now is coming back or page was refreshed)
			if (sesStorage('get', 'intersport-userinfo')) {
				let userinfo = sesStorage('get', 'intersport-userinfo');
				// TODO: User selected other services

				let questions = {};
				for (const question in userinfo.uuid) {
					let el = $('[name="question[]"][data-uuid="' + question + '"]');
					questions[el.data('label')] = userinfo.uuid[question];
				}

				const item = {
					_additionalInfo: { targetgroup: userinfo.targetgroup, ...questions },
					products: sesStorage('get', 'intersport-products') || []
				};

				addProductsFromPackage(item);
			}
		}
	}

	/**
   * Add products as selected in accordion
   * @param {array} item List of items to be added in accordions from cart of fixed package
   */
	function addProductsFromPackage (item) {
		// Have to check both lower- and uppercase properties because uppercase comes from cart and lowercase is used in frontend
		const targetgroup = item._additionalInfo.targetgroup || item._additionalInfo.targetGroup;
		changeTargetGroup($('.btn-package-targetgroup[data-key="' + targetgroup + '"]'));

		// User info
		if (item._additionalInfo) {
			for (const key in item._additionalInfo) {
				if (Object.prototype.hasOwnProperty.call(item._additionalInfo, key)) {
					const value = item._additionalInfo[key];
					let question = $('[name="question[]"][data-label="' + key + '"]');
					if (question) {
						question.val(parseInt(value));
						question.trigger('change');
					}
				}
			}
		}

		// Products
		if (item.products.length > 0) {
			item.products.forEach(product => {
				selectProductFromGroup(product);
			});
		}

		updateSummary(true);

	}

	/**
   * Opens next unlocked empty group
   */
	function openCorrectGroup () {
		$.each($groups, function (i) {
			if (!$(this).hasClass('locked') && !$(this).prev('.package-group').hasClass('disabled')) {
				if (!$(this).data('product') && !$(this).data('fixed-product')) {
					$(this).collapse('show');
					return false; // Only open first category
				}
			}
		});
	}

	// Init group opening
	openCorrectGroup();

	/**
   * Select product from group
   * @param {object} product object of product
   */
	function selectProductFromGroup (product) {
		// Skip installation product
		if (product.isVirtual) return true;

		const selectedItem = {
			id: +product.sap_titlenumber || product.id,
			brand: product.brand_name || product.brand,
			name: product.productname || product.name,
			saptitlenumber: +product.sap_titlenumber || product.saptitlenumber,
			color: product.colorName || product.color,
			colorvalue: product.color || product.colorvalue,
			size: product.size,
			ean: product.ean,
			currentprice: +product.price || product.currentprice,
			packageprice: +product.packagePrice || product.packageprice,
			additionalFields: product.additionalFields,
			preset: null,
			updated: true
		};

		let cat = $('.package-products-wrapper');
		let productCategoryName = product.category_name.toLowerCase();
		$.each(cat, function () {
			let catName = $(this).data('categoryname');
			if (catName === productCategoryName) {
				addProduct(null, $(this), selectedItem, true);
			}
		});
	}

	/**
   * Initialize collapsable product groups
   * @param  {Object} $toggles, jquery object containing group labels
   * @return {Object} jquery object containing group containers
   */
	function initProductGroups ($toggles) {

		// Get product groups from toggles
		// Attach data variables and events
		const $groups = $toggles.map((i, el) => {

			const $toggle = $(el);
			const $group = $($toggle.data('target'));
			const $form = $group.find('form.product-filters');
			const $grid = $group.find('.product-grid');
			const preset = $form.data('preset') || {};

			$group.data('toggle', $toggle);
			$group.data('form', $form);
			$group.data('grid', $grid);
			$group.data('skis', preset.category?.includes('RCa8PG8RQyyw0a7kX7p7Mw'));
			$group.data('shoes', preset.category?.includes('vjNilkvmSZ6IhyuvkuGNiw'));

			if ($group.data('fixed-product')) {
				getFixedProduct($group);
			}

			// Handle filter preset update
			$form.on('filter-preset-update-done', function (ev, data) {
				// Load products if group is open
				if ($group.hasClass('in')) {
					loadGroupProducts($group);
				}
			});

			// Handle product list updates, by listening for global ajax success
			$grid.on('filterProducts', function (ev, response) {
				$group.find('.js-category-cart-container').find('.js-no-products').remove();
				if (response && response.noResults) {
					// If searching skis and no skis found for weight,
					// do new search without height limit
					if (!ignore_ski_height && $group.data('skis')) {
						ignore_ski_height = true;
						updatePackagePresets(null);
					} else {
						$grid.addClass('grid-noresults');
						$grid.html('');
						$group.find('.js-category-cart-container').prepend('<div class="js-no-products"><p class="text-center"><strong>Valitettavasti verkkokaupassa ei ole juuri nyt saatavilla tuotetta, joka vastaa antamiasi lähtötietoja.</strong></p><br></div>');
					}
				} else {
					$grid.removeClass('grid-noresults');
					updateProductGrids();
				}
			});

			// Attach custom click handler to product cards
			$grid.off('click', '.product-list-item a');
			$grid.on('click', '.product-list-item a', openProductLayer);

			$group.find('.close-accordion').on('click', onCloseGroup($group));
			$group.find('.next-productgroup-button').on('click', onNextGroup($group));

			// return dom object, map wraps it to jquery array
			return $group.get();
		});

		return $groups;
	}

	/**
   * Assign product with data to group
   * @param {object} $group group with fixed product
   */
	function getFixedProduct($group) {
		$.get(`/stage-ajax/productList?sapIds=${$group.data('fixed-product')}`).done( data => {
			$.get(`/stage-ajax/packageBuilderProduct?product=${$group.data('fixed-product')}`).done(html => {
				const product = data.products.length > 0 ? data.products[0] : [];
				const manyColors = $(html).find('.product-colors .product-colors-list-item').length > 1;
				const manySizes = $(html).find('.product-sizes .product-sizes-list-item').length > 1;

				let actionText = (manyColors ? 'Väri' : '') + (manyColors && manySizes ? '- ja ' : '') + (manySizes ? 'Koko' : '') + 'tieto tarvitaan';

				let addDirectlyToPackage = false;
				if (!manyColors && !manySizes) {
					// Then product is ready to be added directly to package
					$($group.data('ready', true));
					addDirectlyToPackage = true;
					actionText = null;
				} else {
					$group.data('ready', false);
				}

				const colorText = $(html).find('.product-colors .product-colors-list-item input').data('name')
				const sizeText = $(html).find('.product-sizes .product-sizes-list-item input').data('name')
				const ean = $(html).find('.product-sizes .product-sizes-list-item input').val();

				let item = {
					id: +product.sap_titlenumber,
					brand: product.brand,
					name: product.productname,
					saptitlenumber: +product.sap_titlenumber,
					color: actionText || (colorText !== 'Väritön' ? colorText : ''),
					colorvalue: null,
					size: !manySizes ? sizeText : null,
					ean: addDirectlyToPackage ? ean : null, // If ean is given. Product will be added to package. By not giving ean we create "placeholder product" (fixed product)
					currentprice: parseFloat(product.price),
					packageprice: parseFloat(product.price),
					preset: null,
					updated: true
				};

				let storage = sesStorage('get', 'intersport-products');
				if (storage) {
					storage.filter(_item => {
						if (_item.id === +product.sap_titlenumber) {
							item = _item;
							$($group.data('ready', true));
							addSessionStorageHTML();
						}
					});
				}

				addProduct(null, $group, item, false, true);
			});
		});
	}

	/**
   * Initialize target group selection and height and weight steppers
   */
	function initUserChoices () {

		// Pass initial package builder variables to product filter presets
		uservalues.targetgroup = $('.btn-package-targetgroup').filter('.selected').data('key');
		// Check product group size and weight filters against package questions

		$groups.each(function (i, el) {
			const $group = $(this);
			const config = $group.data('config') || {};
			const sizekey = config.size_question;
			const weightkey = config.weight_question;

			[sizekey, weightkey].forEach(key => {
				if (key && !(key in uservalues)) {
					const el = $(`[data-uuid="${key}"]`);
					if (el.length) {
						uservalues.uuid[key] = Number(el.filter(':valid').val());
						if (el.prop('required')) {
							requiredvalues[key] = true;
						}
					}
				}
			});
		});

		// Set values from select type of questions to uservalues object
		populateShoeSizeSelect(uservalues.targetgroup);
		uservalues.uuid[$('.input-select select[data-uuid]').data('uuid')] = $('.input-select select[data-uuid]').val();

		// Attach handling to found package questions
		$('.input-number input[data-uuid]').keypress(function (event) {
			if ($(this).val().length >= $(this).attr('maxLength')) {
				$(this).val($(this).val().slice(0, $(this).attr('maxLength')))
				return false;
			}
			if (event.which === 13) {
				let inputs = $('.package-inputs .package-input').find('input[data-uuid]');
				let next = inputs.eq(1);
				if (next.data('uuid') === $(this).data('uuid')) {
					$('.input-select select[data-uuid]').focus();
				} else {
					$(next).focus();
				}
			}
		});
		$('.input-number input[data-uuid], .input-select select[data-uuid]').on('click', function () {
			if (checkIfChosenProducts()) {
				$questionsConfirmationContent.find('.js-restart').data($(this).data('uuid'), this.value);
				openModal(null, { compact: true, content: $questionsConfirmationContent, disableBodyScroll: true, onClose: revertInputs });
			}
		});
		$('.input-number input[data-uuid], .input-select select[data-uuid]').on('change', function () {
			if ($(this).is(':valid')) {
				$questionsConfirmationContent.find('.js-restart').data($(this).data('uuid'), this.value);
				updateUserData($(this).data('uuid'));
			}
		});

		// Handle target group changes
		targetgroups.on('click', function () {
			// If products selected
			if (checkIfChosenProducts()) {
				$questionsConfirmationContent.find('.js-restart').data('key', $(this).data('key'));
				openModal(null, { compact: true, content: $questionsConfirmationContent, disableBodyScroll: true, onClose: revertInputs });
			} else {
				changeTargetGroup($(this));
			}
		});

		// Trigger preset update
		updatePackagePresets(uservalues.targetgroup);

		// Number steppers for height and weight in product package hero
		numberstepper('.input-number .input-wrapper');

		// Update total price, when yes/no question changes
		$('input[name="question[]"][data-type="boolean"]').on('change', updateTotalPrice);

	}

	/**
   * Creates options inside select element depending on selected targetgroup
   * @param {string} targetgroup selected group (women, men, youth(young))
   */
	function populateShoeSizeSelect (targetgroup) {
		if (window.shoeSizes) {
			let options = '<option disabled selected></option>'; // Empty option first
			for (let i = 0; i < window.shoeSizes[targetgroup].length; i++) {
				const size = window.shoeSizes[targetgroup][i];
				options += '<option value="' + size + '">' + size + '</option>';
			}
			$('.input-select select[data-uuid]').html(options);
			if (uservalues.uuid[$('.input-select select[data-uuid]').data('uuid')]) {
				$('.input-select select[data-uuid]').val(uservalues.uuid[$('.input-select select[data-uuid]').data('uuid')]);
			}
		}
	}

	/**
   * Reverts all questions (html elements) to uservalues object values
   */
	function revertInputs () {
		$.each($('.package-input input, .package-input select'), function (i) {
			let uuid = $(this).data('uuid');
			let buttonValue = $questionsConfirmationContent.find('.js-restart').data(uuid);
			if (buttonValue !== uservalues.uuid[uuid]) {
				this.value = uservalues.uuid[uuid];
			}
		});
	}

	/**
   * Updates userdata depending if value is given. If no value is given it will use js-restart elements dataset properties to update current question uuid value
   * @param {string} uuid question uuid to update
   * @param {string|int} value String or integer to set the question value (will be converted to number anyway)
   */
	function updateUserData (uuid, value) {
		if (value) {
			uservalues.uuid[uuid] = Number(value);
		} else {
			uservalues.uuid[uuid] = Number($questionsConfirmationContent.find('.js-restart').data(uuid));
		}
		sesStorage('set', 'intersport-userinfo', uservalues);
		sesStorage('remove', 'intersport-products');

		ignore_ski_height = false;
		updatePackagePresets(uservalues.targetgroup);
	}

	/**
   * Checks if there is products added (selected)
   */
	function checkIfChosenProducts () {
		let result = false;
		$groups.each(function (i, el) {
			const $group = $(el);
			const product = $group.data('product');
			if (product) {
				result = true;
			}
		});
		return result;
	}

	/**
   * Resets all groups products so there is no selected products in groups
   */
	function resetGroupsProducts () {
		$groups.each(function (i, el) {
			if ($(el).data('product')) {
				$(el).data('product', null);
			}
		});
		updateGroups();
		updateLabelData();
	}

	/**
   * Changes targetgroup
   * @param {string} targetgroup targetgroup to change to
   */
	function changeTargetGroup (targetgroup) {
		const group = targetgroup.data('key');

		if (group) {
			sesStorage('set', 'intersport-userinfo', { targetgroup: group });
		}

		targetgroups.removeClass('selected');
		targetgroup.addClass('selected');

		if (group !== uservalues.targetgroup) {
			// Store targetgroup products
			// So they can be restored on change
			// targetgroupProductCache[uservalues.targetgroup] = $groups.map(function (i, el) {
			//   return $(el).data('product');
			// }).get();

			uservalues.targetgroup = group;

			// Set validvalues to false
			// Update opens first group, if values are valid
			validvalues = false;

			populateShoeSizeSelect(uservalues.targetgroup);
			updatePackagePresets(uservalues.targetgroup);
		}
	}

	/**
   * Checks values that they are all valid
   */
	function hasValidValues () {
		// Only check when validvalues is set to false
		if (validvalues) return validvalues;

		// Check that each required value is set
		validvalues = true;
		for (let uuid in uservalues.uuid) {
			if (requiredvalues[uuid] && !uservalues.uuid[uuid]) {
				validvalues = false;
			}
		}

		return validvalues;
	}

	/**
   * Pass package builder variables to product filter presets
   */
	function updatePackagePresets (targetgroup) {

		// Request update with custom event
		$groups.each(function (i, el) {
			const $group = $(this);
			const config = $group.data('config') || {};
			const update = {};
			let hasupdate = false;

			if (targetgroup) {
				hasupdate = true;
				update.genders = [targetgroup];

				// Clear products on targetgroup change
				const product = (targetgroupProductCache[targetgroup] && targetgroupProductCache[targetgroup][i]) || null;
				if (i === 0) {
					$group.data('product', product);
					$group.data('toggle').addClass('locked');
				} else {
					resetGroupProduct($group, product);
				}
			}

			if (config.weight_filter && uservalues.uuid[config.weight_question]) {
				const weight = uservalues.uuid[config.weight_question];
				hasupdate = true;
				update.attributes = { user_weight: [weight] };
			}

			if (config.size_filter && uservalues.uuid[config.size_question]) {
				hasupdate = true;
				const size = uservalues.uuid[config.size_question];
				const sizes = [];

				// If ignore_ski_height flag is set, do not calculate height limits
				if (ignore_ski_height && $group.data('skis')) {
					// ignore ski height
				} else {
					// Add filter for each centimeter between min and max height
					const minsize = Math.round(size * config.size_percent + config.size_min);
					let maxsize = Math.round(size * config.size_percent + config.size_max);
					for (let n = minsize; n <= maxsize; n++) {
						sizes.push(n);

						// Include ⅓, ½ and ⅔ sizes for shoes
						if ($group.data('shoes')) {
							sizes.push.apply(sizes, [n + 1/3, n + 1/2, n + 2/3].map(fr => Number(fr.toFixed(5))));
						}
					}
				}

				update.size = sizes;
				$group.data('sizes', sizes);
			}

			if (hasupdate) {
				$group.data('form').trigger('filter-preset-update', [ update ]);
			}
		});

		// Updates group statuses and clears products on targetgroup change
		updateGroups();
	}

	/**
   * filterGroupProducts
   */
	function loadGroupProducts ($group) {
		const $form = $group.data('form');
		const $grid = $group.data('grid');

		$grid.empty();
		addFormLoader($grid);

		if ($group.data('fixed-product')) {
			if ($form.find('input[name="sapIds"]').length > 0) {
				$form.find('input[name="sapIds"]').val($group.data('fixed-product'));
			} else {
				$form.prepend('<input type="hidden" name="sapIds" value="' + $group.data('fixed-product') + '">');
			}
		}

		$form.submit();
	}

	/**
   * accordion
   */
	function accordion() {

		let userConfirmed = false;

		// Handle opening product group collapse
		// Prevents opening locked group, otherwise loads products
		$groups.on('show.bs.collapse', function(e) {
			const $group = $(this);
			const $toggle = $group.data('toggle');

			if ($toggle.hasClass('locked') || $group.data('fixed-product')) {

				if ($group.data('fixed-product')) {
					const item = { id: $group.data('fixed-product').toString(), name: 'Fixed product' };
					openProductLayer(null, item, $group);
				}


				return false;

			} else {

				// If current product has preset cascade and there is product selected in next group then lets show notification about losing the selected product as compatibility of products may change
				let _nextGroup = $group.nextAll('.package-group').eq(0);
				if (_nextGroup.length > 0 && userConfirmed === false) {
					let nextGroupSelectedProduct = $(_nextGroup.data('target')).data('product');
					let currentGroupProductCascade = $group.data('presetCascade');
					if (!Object.prototype.hasOwnProperty.call(currentGroupProductCascade, 'undefined') && nextGroupSelectedProduct) { // Lets show notification
						let html = `
              <div class="container is-fluid questions-confirmation-modal">
                <h3>Tuotteen vaihtaminen vaikuttaa muihin valintoihisi</h3>
                <p>
                  Kaikki tuotteet eivät ole keskenään yhteensopivia. Jos jatkat vaihtamista, saatat joutua muuttamaan myös muita valintojasi.
                </p>
                <button class="a-button js-continue" data-dismiss="modal">Jatka vaihtamista</button>
                <button class="btn-link a-link js-close-modal" data-dismiss="modal">Säilytä alkuperäiset valinnat</button>
              </div>`;
						openModal(null, { compact: true, content: html, disableBodyScroll: true });
						$('.questions-confirmation-modal .js-continue').on('click', function(e) {
							userConfirmed = true;
							$group.collapse('show');
							$.magnificPopup.close();
						});
						$('.questions-confirmation-modal .js-close-modal').on('click', function(e) {
							$.magnificPopup.close();
						});

						sesStorage('remove', 'intersport-products');

						return false;
					}
				} else {
					userConfirmed = false;
				}

				let count = 0;
				$.each($('.package-group'), function (i, val) {
					let el = $(this).data('target');
					if ($(el).data('product')) {
						count++;
						updateLabelData();
					}
				});

				// Group cart content
				if (!$group.data('required')) {
					let templateData = {
						cart: {
							products: count,
							originalAmount: 0, // Will be updated afterwards
							discount: {
								label: 'pakettialennus',
								amount: 0 // Will be updated afterwards
							},
							totalAmount: 0, // Will be updated afterwards
							packageId: $('.product-action-buttons .add-package-to-cart-button').data('packageid')
						},
						nextGroup: {}
					}

					const $nextGroup = $group.nextAll('[data-categoryname]').eq(0);
					if ($nextGroup.length > 0) {
						templateData.nextGroup.label = $nextGroup.data('categoryname');
						templateData.nextGroup.productSelected = $nextGroup.data('product') ? true : false;
					} else {
						delete templateData.nextGroup;
					}

					templateData.cart.originalAmount = $('.price-total').html();
					templateData.cart.discount.amount = $('.price-difference').html();
					templateData.cart.totalAmount = $('.price-package').html();

					let cartContainer = $group.find('.js-category-cart-container');
					$(cartContainer).html(Mustache.render(groupCartTemplate.html(), templateData));

					// Jump to next group
					$.each($(cartContainer).find('.js-select-next-group'), function (i, el) {
						$(el).on('click', function(e) {
							e.preventDefault();
							nextGroup($group);
						});
					});

					// Add package to cart
					$($(cartContainer)).find('.add-package-to-cart-button').on('click', addPackageToCart);
				}

				$toggle.removeClass('collapsed');

				loadGroupProducts($group);

				// Close other contents on desktop
				//if ($(window).width() >= 768) {
				$groups.filter('.in').not(this).collapse('hide');
				//}

				// Push empty history state, for back button handling
				// overlaycount prevents spamming browser history
				if (overlaycount < 1) {
					overlaycount++;
					history.pushState(null, '', '');
				}

				// Trigger resize, because it updates product overlay
				//$(window).resize();

				return true;

			}
		});

		$groups.on('hide.bs.collapse', function() {
			if ($bindingsGroup.length > 0 && skiesWithPreAttachedBindingsAdded()) {
				$bindingsGroup[0].style.setProperty('display','none', 'important'); //need to override bootsrap collapse class !important
			}

			const $group = $(this);
			const $toggle = $group.data('toggle');
			$toggle.addClass('collapsed');
		});
	}

	/**
   * Updates label data of category (atm only in mobile .static-category-listing)
   */
	function updateLabelData () {
		$.each($('.js-update-label-data'), function () {
			const $packageProductsWrapper = $(this).closest('.package-products-wrapper');
			const productData = $packageProductsWrapper.data('product');
			const categoryName = $packageProductsWrapper.data('categoryname');

			if (productData) {
				if (!$(this).prop('originalHTML')) {
					$(this).prop('originalHTML', $(this).html());
				}

				if (productData.colorvalue) {
					$packageProductsWrapper.data('fixed-product-color', productData.colorvalue);
				}

				$(this).find('.js-category-name').text(`${categoryName}:`);
				$(this).find('.js-product-name').text(`${productData.brand} ${productData.name}`);
				let desc = `${productData.color && productData.color !== 'Väritön' && productData.color !== '' ? productData.color : ''}`;
				desc += desc === '' ? `Koko: <strong>${productData.size}</strong>` : `, koko: <strong>${productData.size}</strong>`;
				if (desc === '-') {
					desc = '';
				}
				$(this).find('.desc').html(desc);
				$(this).find('.desc').append('<a href="#" class="js-edit-product"'+ (desc === '' ? ' style="margin-left: 0 !important;"' : '') +'>Muokkaa valintoja</a>');
				$(this).find('.js-edit-product').on('click', function(e) {
					e.preventDefault();
					e.stopPropagation();
					$(this).closest('.package-products-wrapper').find('.product-list-item.in-package a').trigger('click');
				});
			} else if ($(this).prop('originalHTML')) {
				$(this).html($(this).prop('originalHTML'));
			}
		});
	}

	/**
   * addFormLoader
   */
	function addFormLoader($container) {
		removeFormLoader();

		$('<div>', { class: 'product-form-loader' })
			.append($('<div>', { class: 'spinner-loader-circle' }))
			.append($('<div>', { class: 'spinner-loader-circle spinner-loader-circle2' }))
			.append($('<div>', { class: 'spinner-loader-circle spinner-loader-circle3' }))
			.append($('<div>', { class: 'spinner-loader-circle spinner-loader-circle4' }))
			.append($('<div>', { class: 'spinner-loader-circle spinner-loader-circle5' }))
			.append($('<div>', { class: 'spinner-loader-circle spinner-loader-circle6' }))
			.append($('<div>', { class: 'spinner-loader-circle spinner-loader-circle7' }))
			.append($('<div>', { class: 'spinner-loader-circle spinner-loader-circle8' }))
			.append($('<div>', { class: 'spinner-loader-circle spinner-loader-circle9' }))
			.append($('<div>', { class: 'spinner-loader-circle spinner-loader-circle10' }))
			.append($('<div>', { class: 'spinner-loader-circle spinner-loader-circle11' }))
			.append($('<div>', { class: 'spinner-loader-circle spinner-loader-circle12' }))
			.appendTo($container);
	}

	/**
   * removeFormLoader
   */
	function removeFormLoader() {
		$formAlertContainer.find('.product-form-loader').remove();
	}

	/**
   * showFormMessage
   *
   * @param {String} msg
   * @param {Boolean} isError
   */
	function showFormMessage(msg, isError, $container = null) {
		$container = $container || $formAlertContainer;

		clearFormMessages($container);

		$('<div>', { class: 'product-form-alert' + (isError ? ' is-error' : ''), text: msg }).appendTo($container);
	}

	/**
   * clearFormMessages
   */
	function clearFormMessages($container = null) {
		$container = $container || $formAlertContainer;

		$container.find('.product-form-alert').remove();
	}

	/**
   * updateProductGrids
   */
	function updateProductGrids () {
		$groups.each(function (i, el) {

			const $group = $(el);
			const $grid = $group.data('grid');
			const product = $group.data('product');

			$grid.find('.product-list-item').removeClass('in-package');
			if (product) {
				$grid.find('.product-list-item[data-id="' + product.id + '"]').addClass('in-package');
			}

			// Toggle fixed next product group button, visible on mobile
			$group.find('.next-productgroup-button').toggleClass('disabled', !product && !!$group.data('required'));

		});
	}

	function openColor (e) {
		e.preventDefault();
		e.stopPropagation();
		const identifier = $(this).data('identifier');
		const builder = $('.package-builder');
		const colorProduct = builder.find('.product-list-item[data-identifier="' + identifier + '"] a').first();

		if (colorProduct.length) {
			// Normal package
			colorProduct.trigger('click');
		} else {
			const idArr = identifier.split('_');
			const group = builder.find('[data-fixed-product="'+idArr[0]+'"]').first();
			if (group.length) {
				// Fixed product package
				const item = { id: group.data('fixed-product').toString(), color: idArr[1], name: 'Fixed product' };
				openProductLayer(null, item, group);
			}
		}
	}

	/**
   * openProductLayer
   */
	function openProductLayer (e, item, group) {
		if (e) {
			e.preventDefault();
			e.stopPropagation();
		}

		let items_unordered = [],
			index = 0,
			$group = group || $(this).closest('.package-products-wrapper');

		if (item && group) {
			let url = '/stage-ajax/packageBuilderProduct?product=' + item.id;
			const color = group.data('fixed-product-color');
			if (item.color) {
				url += '&color=' + item.color;
			} else if (color) {
				url += '&color=' + color;
			}
			items_unordered.push(
				{
					src: url,
					label: item.name
				}
			);
		} else {
			// Find the clicked product, product grid, group and all product items
			const $item = $(this).closest('.product-list-item');
			const $grid = $(this).closest('.product-grid');
			const $items = $grid.find('.product-list-item');
			index = $items.index($item);

			// Format items for magnific popup ajax gallery
			items_unordered = $items.map((i, el) => {
				const identifier = $(el).data('identifier');
				const idArr = identifier.split('_');
				return {
					src: '/stage-ajax/packageBuilderProduct?product=' + idArr[0] + '&color=' + idArr[1],
					label: $(el).find('.product-name').text()
				}
			}).get();
		}

		// Slice items to start with clicked product
		const items = items_unordered.slice(index)
			.concat(items_unordered.slice(0, index));

		// Push empty history state, for back button handling
		// overlaycount prevents spamming browser history
		if (overlaycount < 2) {
			overlaycount++;
			history.pushState(null, '', '');
		}

		// Open magnific popup ajax gallery
		$.magnificPopup.open({
			items: items,
			mainClass: 'v4-typography package-product-layer',
			type: 'ajax',
			fixedContentPos: true,

			// Define texts and markup
			closeMarkup: '<button type="button" class="mfp-close"><i class="is-icon is-icon-close"></i> %title%</button>',
			tClose: 'Sulje',
			tLoading: 'Odota, tietoja haetaan...',
			ajax: {
				tError: 'Tuotetietojen hakeminen epäonnistui'
			},
			gallery: {
				enabled: true,
				arrowMarkup: '<button type="button" type="button" class="mfp-arrow mfp-arrow-%dir%"><i class="is-icon is-icon-arrow mfp-prevent-close"></i> <span class="mfp-arrow-title mfp-prevent-close">%title%</span></button>',
				tPrev: '',
				tNext: '',
				tCounter: ''
			},

			callbacks: {

				afterClose: function () {
					$('html,body').scrollTop($group.data('toggle').offset().top);
				},

				beforeOpen: function() {
					$('body').css('overflow', 'hidden');
				},

				beforeClose: function() {
					$('body').css('overflow', 'auto');
				},

				// Handle changing item
				// Change next and previous labels
				change: function () {
					const items = $.magnificPopup.instance.items;
					const index = $.magnificPopup.instance.index;
					const gallery = $.magnificPopup.instance.st.gallery;

					const prev = items[(index - 1 + items.length) % items.length];
					const next = items[(index + 1) % items.length];

					gallery.tPrev = prev.label || prev.data.label;
					gallery.tNext = next.label || next.data.label;

					$('.mfp-arrow-left .mfp-arrow-title').text(gallery.tPrev);
					$('.mfp-arrow-right .mfp-arrow-title').text(gallery.tNext);
				},

				// Preprocess plain html from server
				parseAjax: function(mfpResponse) {
					let nextlabel;

					const nextGroupIndex = $groups.index($group) + 1;
					if (nextGroupIndex < $groups.length) {
						nextlabel = 'Jatka valitsemaan ' + $groups.eq(nextGroupIndex).data('categoryname');
					} else {
						nextlabel = 'Jatka yhteenvetoon';
					}

					const nextbutton = `<button type="button" class="button next-productgroup-button disabled">${nextlabel}</button>`;

					mfpResponse.data = $(`<div class="package-product-layer-wrapper">
																	<div class="package-product-layer-content">${mfpResponse.data}</div>
																	${nextbutton}
																</div>`);
				},

				// Content has been added to DOM, attach logic
				ajaxContentAdded: function() {
					const $layer = $(this.content);
					const $form = $layer.find('form.product-form');
					const $addbutton = $layer.find('.add-to-package-button');
					const $nextbutton = $layer.find('.next-productgroup-button');
					const $colorSelect = $layer.find('.product-colors-list .product-colors-list-item');

					const product = $group.data('product') || {};
					const colorsel = `[name="color"][value="${product.colorvalue}"]`;
					const $color = $form.find(colorsel);
					const sizesel = `[name="ean"][value="${product.ean}"]`;
					const $size = $form.find(sizesel);
					const added = $size.length > 0;
					const required = !!$group.data('required');
					const config = $group.data('config') || {};

					if ($group.data('fixed-product')) {
						$layer.find('.add-to-package-string').text('Tallenna valinnat');
						$layer.find('.in-package-string').text('Valinnat tallennettu');
					} else {
						$layer.find('.add-to-package-string').text('Lisää pakettiin');
						$layer.find('.in-package-string').text('Paketissa');
					}

					$addbutton.addClass('disabled');
					$addbutton.toggleClass('added', added);
					$nextbutton.toggleClass('disabled', !added && required);

					//special case for pre-attached bindings
					const productCategoryName = $group.data('categoryname');
					if (added && productCategoryName === 'sukset') {
						if ($bindingsGroup.length > 0 && skiesWithPreAttachedBindingsAdded()) {
							$nextbutton.on('click', onNextGroup($bindingsGroup));
							$nextbutton.html('Jatka valitsemaan monot');
						}
					}

					productPage($layer.find('.v4-product-card'));
					$addbutton.on('click', onToggleProduct($group, $layer));
					$nextbutton.on('click', onNextGroup($group));
					$colorSelect.on('click', openColor);
					$layer.find('.close-layer').on('click', (ev) => {
						ev.preventDefault();
						// Close product modal
						$.magnificPopup.close();
						// Close accordion
						$('html,body').scrollTop($group.data('toggle').offset().top);
						$group.collapse('hide');
					});

					$form.append('<div class="v4-product-click-and-collect v4-typography transition-done plain"></div>');

					// Ski binding checkbox
					if ($form.data('category') === 'Siteet') {
						let $summaryRow = $('.package-summary .package-options');
						$summaryRow.clone().insertAfter($form.find('.product-colors'));
						$form.find('.styled-checkbox input[type="checkbox"]').prop('name', ''); // Remove the name of input so there will be no duplicate triggers

						if ($form.find('.detail-price .discount')) {
							$form.find('.detail-price .normal').remove();
						}

						$form.find('.styled-checkbox input[type="checkbox"]').on('change', function() {
							let summaryCheckbox = $summaryRow.find('input[type="checkbox"]');
							$(this).is(':checked') ? summaryCheckbox.prop('checked', true) : summaryCheckbox.prop('checked', false);
							updateTotalPrice();
						});
					}

					const checkForMiscButtons = function (e) {
						$form.find('.builder-misc-buttons').remove();
						if ($layer.find('input[data-available-in-web="false"]').is(':checked')) {
							if ($form.find('.builder-misc-buttons').length === 0) {
								$form.find('.product-action-buttons').after('<div class="builder-misc-buttons"><a href="#" class="js-select-another-product product-builder-another-product-button">Valitse vaihtoehtoinen tuote</a></div>');
								$('.js-select-another-product').on('click', function(e) {
									e.preventDefault();
									e.stopPropagation();
									$group.data('fixed-product', false);
									$.magnificPopup.close();
									$group.collapse('show');
									$group.prev().find('.no-arrow').removeClass('no-arrow');
								});
							}
						}
					}

					// if (config.size_filter || config.weight_filter) {
					$layer.find('.product-sizes').addClass('recommended');

					// Handle sizes: Hide sizes that do not match user height or weight, and preselect matching size
					const filterSizes = function(e) {
						$layer.find('.product-sizes-list-item').each(function (i, el) {
							const $size = $(this);
							const $input = $size.find('input');
							const size = Number($input.data('numeric'));
							const attributes = $input.data('attributes');
							const sizes = $group.data('sizes') || [];
							if ((config.size_filter && sizes.length && sizes.indexOf(size) === -1)
                  || (config.weight_filter && attributes && attributes.user_weight
                      && (Number(attributes.user_weight.min) > uservalues.uuid[config.weight_question]
                          || Number(attributes.user_weight.max) < uservalues.uuid[config.weight_question]))) {
								$size.addClass('hidden');
							}

							// Set matching user given shoe size and product size as checked
							if (sizes.indexOf(size)) {
								if (size === uservalues.uuid[config.size_question]) {
									$input.prop('checked', true);
									$form.find('.v4-product-click-and-collect').html('<div id="click-and-collect-content" class="click-and-collect-content"></div>');
									setTimeout(() => {
										if ($group.data('allow-replacement') && $group.data('fixed-product')) {
											checkForMiscButtons();
										}
										clickAndCollect(true);
									}, 250);
								}
							}

							// Trigger cnc on click of size button
							$size.on('click', () => {
								// Click and collect element
								if ($size.parent().find('input[type="radio"]').is('[data-available-in-stores=\'true\'][data-available-in-web=\'true\']')) {
									$form.find('.v4-product-click-and-collect').html('<div id="click-and-collect-content" class="click-and-collect-content"></div>');
									setTimeout(() => {
										if ($group.data('allow-replacement') && $group.data('fixed-product')) {
											checkForMiscButtons();
										}
										clickAndCollect(true);
									}, 250);
								}
							});

						});

						// Preselect size if it's the only option
						const $sizes = $layer.find('.product-sizes-list-item:not(.hidden)');
						if ($sizes.length === 1) {
							$sizes.find('input').prop('checked', true);
						}
					};
					filterSizes();

					// Trigger filterSizes on color change
					$form.on('productColorChange', '[name="color"]', filterSizes);
					// }

					// Trigger cnc if there is only 1 or less sizes
					if ($layer.find('.product-sizes-list-item').length <= 1) {
						$layer.find('.product-sizes-list-item input').prop('checked', true);
						if ($layer.find('.product-sizes-list-item input').is('[data-available-in-stores=\'true\'][data-available-in-web=\'true\']')) {
							$form.find('.v4-product-click-and-collect').html('<div id="click-and-collect-content" class="click-and-collect-content"></div>');
							setTimeout(() => {
								if ($group.data('allow-replacement') && $group.data('fixed-product')) {
									checkForMiscButtons();
								}
								clickAndCollect(true);
							}, 250);
						}
					}

					// If product is in package, update automatically on change
					if (added) {
						$form.on('productColorChange', '[name="color"]', function () {
							const $size = $form.find(sizesel);
							$size.prop('checked', true);
						});
						$form.on('change', '[name="ean"]', function() {
							const $size = $(this);
							if ($size.data('available-in-web') && $addbutton.hasClass('added')) {
								addProduct($form, $group, false, false, false, true);
							}
						});
						$color.prop('checked', true);
						setTimeout(() => {
							if ($group.data('allow-replacement') && $group.data('fixed-product')) {
								checkForMiscButtons();
							}
							clickAndCollect(true);
						}, 250);
					}
				}
			}
		});
	}

	function onCloseGroup ($group) {

		return function (e) {
			if (e) e.preventDefault();
			$('html,body').scrollTop($group.data('toggle').offset().top);
			$group.collapse('hide');
		};

	}

	/**
   * onNextGroup, create handler for continuing to next product group
   */
	function onNextGroup ($group) {

		return function (e) {
			if (e) e.preventDefault();

			const $nextbutton = $(this);
			if (!$nextbutton.hasClass('disabled')) {
				nextGroup($group);
			}
		};
	}

	/**
   * nextGroup, continue to next product group
   */
	function nextGroup ($group) {
		// Close popup
		$.magnificPopup.close();

		// Move to next group
		$group.collapse('hide');

		const nextGroupIndex = $groups.index($group) + 1;
		if (nextGroupIndex < $groups.length) {
			$('html,body').scrollTop($group.data('toggle').offset().top);
			$groups.eq(nextGroupIndex).collapse('show');
		}
	}

	/**
   * onToggleProduct, create handler for toggling selected product to package
   */
	function onToggleProduct ($group, $layer) {

		return function (e) {
			if (e) e.preventDefault();

			const $form = $layer?.find('form.product-form');
			const $addbutton = $layer?.find('.add-to-package-button');
			const $nextbutton = $layer?.find('.next-productgroup-button');

			// Check that color and size has been selected
			const colorValue = $form?.find('[name="color"]').val();
			const eanSelected = $form?.find('[name="ean"]:checked').closest('.product-sizes-list[data-color="' + colorValue + '"]').length;
			const required = !!$group.data('required');

			const action = (!$layer || $addbutton.hasClass('added')) ? 'remove' : 'add';

			const fixedProduct = $group.data('fixed-product');

			// Remove from package
			if (action === 'remove') {
				resetGroupProduct($group);
				updateGroups();
				updateProductGrids();
				$group.data('ready', false)

				// Remove product from session storage too
				const storageProducts = sesStorage('get', 'intersport-products');
				if (storageProducts) {
					const productsWithoutRemoved = storageProducts.filter(product => $group.data('categoryname') !== product.category_name.toLowerCase());
					sesStorage('remove', 'intersport-products');
					sesStorage('set', 'intersport-products', productsWithoutRemoved);
				}

				$addbutton?.removeClass('added');
				$nextbutton?.toggleClass('disabled', required);

				if (fixedProduct) {
					getFixedProduct($group);
					$group.removeData('fixed-product-color');
				}

				if ($group.data('categoryname') === 'sukset') {
					handlePreAttachedBindings(false);
				}

			} else if ($addbutton.hasClass('disabled') || !eanSelected) {

				if (!eanSelected) {
					showFormMessage($form.data('sizeInfoText'), true, $form.find('#product-alert-container'));
				}
				$nextbutton.toggleClass('disabled', required);

				// Add to package
			} else {
				$group.data('ready', true);
				addProduct($form, $group);
				updateProductGrids();

				$addbutton.addClass('added');

				//special case for pre-attached bindings
				const productCategoryName = $group.data('categoryname');
				if ($bindingsGroup.length > 0 && productCategoryName === 'sukset' && skiesWithPreAttachedBindingsAdded()) {
					$nextbutton.on('click', onNextGroup($bindingsGroup));
					$nextbutton.html('Jatka valitsemaan monot');
				}

				$nextbutton.removeClass('disabled');

				// On desktop continue automatically
				if ($(window).width() > 768) {
					nextGroup($group);
				}
			}

			// Remove :focus style
			$addbutton?.blur();
		};

	}

	function updateSkiesNextGroupButton(skipBindings = false) {
		const $skiesGroup = $('#package-products-0');
		const $nextGroupButton = $skiesGroup.find('.next-productgroup-button')

		if (skipBindings && $bindingsGroup.length > 0) {
			$nextGroupButton.on('click', onNextGroup($bindingsGroup));
			$nextGroupButton.html('Jatka valitsemaan monot');
		} else {
			$nextGroupButton.on('click', onNextGroup($skiesGroup));
			$nextGroupButton.html('Jatka valitsemaan siteet');
		}
	}

	function skiesWithPreAttachedBindingsAdded() {
		const sesStorageProducts = sesStorage('get', 'intersport-products');

		if (sesStorageProducts) {
			return sesStorageProducts.some((product) => {
				return product.additionalFields?.some((field) => {
					return field.uuid === 'C7DhLWX-RYqYNIQ9Ejy-uQ' && field.value === 'kyllä'; // Siteet asennettuna -- kyllä
				})
			});
		} else {
			return false
		}
	}

	/**
	 * Handle case "pre-attached bindings".
	 */
	function handlePreAttachedBindings(activate = false) {
		if ($bindingsGroup.length === 0) return;

		updateSkiesNextGroupButton(activate);

		if (!activate) {
			$('.package-group[data-target="#package-products-1"]').show().removeClass('disabled');
			$('.package-summary .detail-section.package-options').removeClass('pre-attached-bindings');
			$bindingsGroup[0].style.setProperty('display','initial');
			sesStorage('remove', 'additionalFields');
		} else {
			$('.package-group[data-target="#package-products-1"]').hide().addClass('disabled'); //bindings toggle
			$('.package-summary .detail-section.package-options').addClass('pre-attached-bindings');
			$bindingsGroup[0].style.setProperty('display','none', 'important'); //need to override bootsrap collapse class !important

			//continue automatically to boots selection on desktop
			if ($(window).width() > 768) {
				nextGroup($bindingsGroup);
			}
		}
	}

	/**
	 * Remove same category product from session storage and add new.
	 * @param {Object} addedProduct - product to be added to session storage
	 */
	function updateSessionStorage(addedProduct) {
		if (addedProduct.category_name && addedProduct.ean) {
			const sesStorageProducts = sesStorage('get', 'intersport-products') || [];
			const productsTobeSaved = sesStorageProducts.filter(storedProduct => storedProduct.category_name !== addedProduct.category_name);
			sesStorage('remove', 'intersport-products');
			sesStorage('set', 'intersport-products', [...productsTobeSaved, addedProduct]);
		}
	}

	/**
   * addProduct, add selected product to package
   */
	function addProduct ($form, $group, $product, useCartAdditionalFields = false, ignoreAdditionalFields = false, fromProductLayer = false) {

		let product = {};

		if ($product) {
			product = $product;
		} else {
			// Normalize product info
			const $color = $form.find('[name="color"]');
			const $size = $form.find('[name="ean"]:checked');

			const colorVal = $color.val();
			$group.data('fixed-product-color', colorVal);

			product = {
				id: +$form.data('sap-titlenumber'),
				brand: $form.data('brand-name'),
				name: $form.data('product-name'),
				saptitlenumber: $form.data('sap-titlenumber'),
				additionalFields: $form.data('additional-fields'),
				color: $color.data('name'),
				colorvalue: colorVal,
				size: $size.data('name'),
				ean: $size.val(),
				currentprice: parseFloat($form.data('current-price')),
				packageprice: parseFloat($form.data('package-price')),
				preset: null,
				updated: true
			};
		}

		const bindingsArePreAttached = product.additionalFields?.some((field) => {
			return field.uuid === 'C7DhLWX-RYqYNIQ9Ejy-uQ' && field.value === 'kyllä'; //siteet asennettuna - kyllä
		});


		// Use product's additional fields as filter preset for next group
		// e.g. filter ski boots by the binding type
		if (!ignoreAdditionalFields) {
			const presetCascade = $group.data('preset-cascade');
			if (typeof presetCascade === 'object') {
				product.preset = {};

				let additional = [];
				if (useCartAdditionalFields) {
					additional = product.additionalFields;
				} else {
					additional = $form.data('additional-fields');
					product.additionalFields = additional;
				}

				for (let n = 0; n < additional.length; n++) {
					const name = additional[n].name;
					if (name in presetCascade) {
						product.preset[presetCascade[name]] = additional[n].value.split(/\s*,\s*/);
					}
				}
			}
		}

		const productCategoryName = $($group).data('categoryname');
		if (product.ean) {
			product.category_name = productCategoryName
			updateSessionStorage(product); //remove same category elements from session storage and add new product
		}

		// Store product info to group data
		$group.data('product', product);
		$formAlertContainer.empty();

		// Update selected product information and group status classes
		updateGroups();
		updateProductGrids();

		if (productCategoryName === 'sukset' && !fromProductLayer) {
			if (bindingsArePreAttached) {
				handlePreAttachedBindings(product);
			} else {
				handlePreAttachedBindings();
			}
		}
	}

	/**
   * resetGroupProduct, mark group product for removal or replace with another product
   * @param  {Object} $group, jquery object for product group
   * @param  {Object} replace, replacement product data
   */
	function resetGroupProduct ($group, replace = null) {
		$group.data('product', replace || { updated: true, removed: true });
	}

	/**
   * updateGroups, update product group states based on added products
   */
	function updateGroups () {

		let enablenext = true;
		let clearnextproducts = false;
		let presetnext;
		let packageready = true;

		$groups.each(function (i, el) {

			const $group = $(el);
			const $toggle = $group.data('toggle');
			const required = $group.data('required') === 1 ? true : false;

			// Clear products
			if (clearnextproducts) {
				let prevGroup = $group.prevAll('.package-group').eq(1);
				if (prevGroup.length > 0) {
					let prevGroupProductCascade = $(prevGroup.data('target')).data('presetCascade');
					if (!Object.prototype.hasOwnProperty.call(prevGroupProductCascade, 'undefined') && $group.data('product')) {
						$group.data('product', null);
					}
				}
				updateLabelData();
			}

			// Get product and update group state
			let product = $group.data('product');

			if (hasValidValues() && enablenext) {

				// Automatically open first group on desktop
				if (i === 0 && $(window).width() >= 768 && $toggle.hasClass('locked')) {
					$toggle.removeClass('locked');
					setTimeout(() => {
					  if ($('.package-group:not(".collapsed")').length === 0) {
					    $groups.eq(0).collapse('show');
					  }
					}, 500);

					// Or just unlock group
				} else {
					$toggle.removeClass('locked');
				}

			} else {
				$toggle.addClass('locked');
				$group.filter('.in').collapse('hide');
			}

			if (presetnext) {
				// Defines next groups product category products (additional_fields category)
				$group.data('form').trigger('filter-preset-update', [ presetnext ]);
			}

			// Set flags for following groups
			presetnext = null;
			if (product && product.updated) {

				if (product.removed) {
					product = null;
					$group.data('product', null);
					if ($(window).width() >= 768) {
						$group.filter('.in').collapse('hide');
					}

				} else {
					product.updated = false;

					// Update next groups preset, when product changes
					if (product.preset) {
						presetnext = product.preset;
					}

				}

				// If required product changes, clear selected products below it
				clearnextproducts = required;

			}
			enablenext = (product || (enablenext && !required));

			// Update package state
			if (required && !product || $group.data('fixed-product') && !$group.data('ready')) {
				packageready = false;
			}

			const $categoryName = $toggle.find('.category-name');

			// Update selected product markup
			if (product) {
				$toggle.addClass('selected');

				const priceFormatted = formatPrice(product.packageprice);
				let productDesc = `${product.color && product.color !== 'Väritön' && product.color !== '' ? product.color : ''}`;
				if (product.size) {
					productDesc += productDesc === '' ? `Koko: <strong>${product.size}</strong>` : `, koko: <strong>${product.size}</strong>`;
				}
				if (productDesc === '-') {
					productDesc = '';
				}

				if (product.colorvalue) {
					$group.data('fixed-product-color', product.colorvalue);
				}

				const categoryName = $group.data('categoryname');
				const categoryNameMarkup = `${categoryName}:`;
				$categoryName.html(categoryNameMarkup);

				const productNameMarkup = `
          <span class="name">${product.brand} ${product.name}</span>
					<div class="desc">
						${productDesc}
					</div>
					<div class="package-group__link-group">
						<span class="link a-link js-remove-product">Poista</span>
						<span class="link a-link">Muokkaa</span>
					</div>`;
				$toggle.find('.product-name').html(productNameMarkup);
				$toggle.find('.js-remove-product').click(onToggleProduct($group));

				const productPriceMarkup = `${priceFormatted}`;
				$toggle.find('.price').html(productPriceMarkup);

				if (i === $groups.length - 1) {
					setTimeout(() => {
						let top = $(window).width() >= 768 && $(window).width() < 1024 ? $container.offset().top - $('.header-content-mobile').outerHeight() : $container.offset().top;
						$('html,body').scrollTop(top);
					}, 250);
				}

			} else {
				$toggle.removeClass('selected');
				$toggle.find('.product-name').empty();
				$toggle.find('.price').html(formatPrice(0));
			}

		});

		// Update prices in summary
		updateSummary(packageready);
	}

	/**
   * updateSummary, update summary price and state
   */
	function updateSummary (packageready) {
		updateTotalPrice();
		if (packageready) {
			// $('.js-summary-details').removeClass('disabled');
			$cartbutton.removeClass('disabled');
		} else {
			// $('.js-summary-details').addClass('disabled');
			$cartbutton.addClass('disabled');
		}
	}

	/**
   * updateTotalPrice, calculate package price based on added products
   */
	function updateTotalPrice () {
		let totalprice = 0;
		let packageprice = 0;
		let pricedifference;
		ignoreFixedPrice = false;

		$groups.each(function (i, el) {
			const $group = $(el);
			const product = $group.data('product');
			const minAmount = $group.data('min-amount') || 1;

			if (product) {
				totalprice += typeof(product.currentprice) === 'string' ? +product.currentprice * minAmount : product.currentprice * minAmount;
				packageprice += typeof(product.packageprice) === 'string' ? +product.packageprice * minAmount : product.packageprice * minAmount;
				if (product.saptitlenumber !== $group.data('fixed-product') && product.ean) {
					ignoreFixedPrice = true;
				}
			}
		});

		$('input[name="question[]"]:checked').each((index, el) => {
			const $el = $(el);
			const discount = Number($el.data('discount'));
			if (discount > 0) {
				totalprice += discount;
			}
		});

		let packagepriceFormatted = formatPrice(packageprice);

		if ($('.price-package').data('fixed-price') > 0 && !ignoreFixedPrice) {
			pricedifference = -($('.price-package').data('fixed-price') - packageprice);
			packagepriceFormatted = formatPrice($('.price-package').data('fixed-price'));
		} else {
			pricedifference = totalprice - packageprice;
		}

		$('.price-package').html(packagepriceFormatted);

		const totalpriceFormatted = formatPrice(totalprice);
		const pricedifferenceFormatted = formatPrice(-pricedifference);
		$('.price-total').html(totalpriceFormatted);
		$('.price-difference').html(pricedifferenceFormatted);
	}

	function formatPrice (number) {
		if (typeof(number) === 'string') {
			number = +number;
		}
		return number.toFixed(2).replace('.', ',') + ' €';
	}

	/**
   * addPackageToCart
   */
	function addPackageToCart () {
		headerCart.forceNewCart();
		//const packageid = ignoreFixedPrice ? null : $(this).data('packageid');
		const packageid = $(this).data('packageid');
		const amount = 1;
		const eans = $groups.map((i, el) => {
			const product = $(el).data('product');
			return product ? product.ean : null;
		}).get().filter(ean => ean);

		const additional = {};
		$('input[name="question[]"], select[name="question[]"]').each((index, el) => {
			const $el = $(el);
			switch ($el.data('type')) {
				case 'number':
					additional[$el.data('label')] = el.value + ' ' + $el.data('unit');
					break;
				case 'boolean':
					additional[$el.data('label')] = el.checked ? 'kyllä' : 'ei';
					if (el.checked && $el.data('ean')) {
						eans.push($el.data('ean'));
					}
					break;
				default:
					additional[$el.data('label')] = el.value;
					break;
			}
		});

		if (uservalues.targetgroup) {
			additional.targetgroup = uservalues.targetgroup;
		}

		const formErrorMessage = $cartbutton.data('formErrorText');

		$cartbutton.prop('disabled', true);
		$cartbutton.addClass('disabled');
		clearFormMessages();
		addFormLoader();


		cart.addItem(eans, amount, packageid, additional)
			.then(function(response) {
				if (response && response.result === 1) {
					headerCart.updateHeaderCart(true, response.cart, false, response.itemId);
					$container.data('item', null);
					updatePackagePresets(uservalues.targetgroup);
					// setTimeout(() => {
					//   $('html,body').scrollTop(0);
					// }, 500);
					//showFormMessage(formSuccessMessage);
					//$container.data('item', response.itemId);
					//GoogleTagManager.addToCart($form.data('sapTitlenumber'), amount, ean, $form.data('productName'), $form.data('brandName'));
				} else if (response && response.messages && response.messages.length) {
					showFormMessage(response.messages[0].message, true);
				} else {
					showFormMessage(formErrorMessage, true);
				}
				return true;
			})
			.catch(function(error) {
				showFormMessage(formErrorMessage, true);
			})
			.finally(function() {
				removeFormLoader();
				$cartbutton.prop('disabled', false);
			});

	}
}
